// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__34s5Q","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2fQcL"};